/** @module csi/skintheme/VioletMist */
define([], function() {
	return {
		Blue1: "Purple30",
		Blue2: "Purple50",
		Blue3: "Purple300",

		PrimaryBlue: "MutedPurple600",
		PrimaryDisabledColor: "Purple100",
		PrimaryColor2: "MutedPurple700",
		PrimaryColor3: "Purple900",

		SiteHeaderBackground: "MutedPurple600",

		CompanyHeaderBlue1: "MutedPurple600",
		CompanyHeaderBlue2: "MutedPurple700",

		/* LINK */
		LinkNormal: "Purple600",
		LinkHover: "Purple800",
		LinkActive: "Purple600",

		/* Comment */
		CommentActiveColor: "Purple600",

		/** custom view */
		CustomViewOptionActiveColor: "Purple400",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "MutedPurple600",
		FullScreenLogoBackgroundColor: "MutedPurple600",

		/* TEXT */
		TabsTextActive: "MutedPurple700",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Purple900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "MutedPurple600",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Purple600",

		/* CheckBox */
		CheckBoxFocusColor: "Purple300",

		/* Text Border */
		TextfieldActiveBorderColor: "MutedPurple600",
		BtnToolbarFocusedBorderColor: "MutedPurple600",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* Header */
		LastVisitedBackgroundColor: "PrimaryWhite",
		LastVisitedIconColor: "SiteHeaderBackground",
		PageHeaderButtonTextColor: "PrimaryWhite",
		PageHeaderToolbarIconColor: "PrimaryWhite",
		PageHeaderToolbarHoverColor: "PrimaryWhite",
		PageHeaderSearchScopeBackgroundColor: "BtnSecondaryNormalBackgroundColor",
		PageHeaderSearchBlockBackgroundColor: "TextfieldNormalBackgroundColor",
		PageHeaderSearchInButtonHoverColor: "BtnSecondaryHoverBackgroundColor",
		PageHeaderToolbarSeparatorColor: "WhiteOpacity20",
		CompanyLogoTextColor: "WhiteTextColor",
		CompanyLogoImageURL: "DarkCompanyLogoIconURL",
		ExitFullScreenIconURL: "DarkExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "MutedPurple600",
		TablePasteBorderColor: "MutedPurple600",
		TableNewRowBackgroundColor: "Purple100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Purple100",

		/* Chart */
		ChartAreaURL: "ChartAreaPurpleURL",
		ChartBarURL: "ChartBarPurpleURL",
		ChartColumnURL: "ChartColumnPurpleURL",
		ChartDoughnutURL: "ChartDoughnutPurpleURL",
		ChartLineURL: "ChartLinePurpleURL",
		ChartMsAreaURL: "ChartMsAreaPurpleURL",
		ChartMsBarURL: "ChartMsBarPurpleURL",
		ChartMsColumnURL: "ChartMsColumnPurpleURL",
		ChartMsLineURL: "ChartMsLinePurpleURL",
		ChartParetoURL: "ChartParetoPurpleURL",
		ChartPieURL: "ChartPiePurpleURL",
		ChartStackedAreaURL: "ChartStackedAreaPurpleURL",
		ChartStackedBarURL: "ChartStackedBarPurpleURL",
		ChartStackedColumnURL: "ChartStackedColumnPurpleURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Purple50"
	};
});